import React from 'react';
import RentalDrivers from '../components/RentalDrivers';

export default ({rental: {drivers = []}} = {}) =>
  [...drivers].map(({driver}) => (
    <RentalDrivers key={`driver_${driver.id}`} driver={driver} />
  ));
